import md5 from 'blueimp-md5'
export const hash = (str: string) => md5(str)
